<template>
	<v-container>
		<v-card v-if="isLoading" class="text-xs-center">
			<v-container>
				<v-progress-circular
					:size="70"
					:width="7"
					color="primary"
					indeterminate
				></v-progress-circular>
			</v-container>
		</v-card>
		<component v-else :is="getComponent" :item="page"></component>
	</v-container>
</template>

<script>
import { mapState } from 'vuex';

import Question from '../components/Question.vue';
import Finish from '../components/Finish.vue';
import Contact from '../components/Contact.vue';
import NoticeDate from '../components/NoticeDatePage.vue';
import CommencePage from '../components/CommencePage.vue';

export default {
	computed: {
		...mapState({
			page: 'page',
			isLoading: 'isLoading',
		}),
		getComponent() {
			return {
				question: Question,
				finish: Finish,
				contact: Contact,
				'notice-date': NoticeDate,
				commence: CommencePage,
			}[this.page.type];
		},
	},
	watch: {
		$route(to, from) {
			this.$store.dispatch('getPage', to.params.id);
		},
	},
	updated() {
		window.parent.postMessage(
			{
				event: 'resize',
				height: Math.max(
					document.body.offsetHeight,
					document.documentElement.offsetHeight
				),
			},
			'*'
		);
	},
	created() {
		this.$store.dispatch('getPage', this.$route.params.id);
	},
};
</script>
